// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"meditationbackground_scrollbar__3mhfc"};